// frontend/src/components/auth/register/LanguageSelector.tsx

import React, { useState } from "react";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import { LanguageOutlined as LanguageIcon } from "@mui/icons-material";
import {
  VERDE_MENTA,
  FUNDO_PAPEL,
  TEXTO_PRIMARIO,
  withAlpha,
} from "../../../themes/themeConstants";

interface LanguageSelectorProps {
  currentLang: string;
  onChangeLang: (lang: string) => void;
}

const languages: Record<string, string> = {
  pt: "Português",
  en: "English",
};

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  currentLang,
  onChangeLang,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLangChange = (lang: string) => {
    onChangeLang(lang);
    handleClose();
  };

  return (
    <Box sx={{ position: "absolute", top: 20, right: 20 }}>
      <Tooltip title="Selecionar idioma">
        <IconButton
          onClick={handleClick}
          size="medium"
          sx={{
            color: VERDE_MENTA,
            background: withAlpha(VERDE_MENTA, 0.1),
            "&:hover": {
              background: withAlpha(VERDE_MENTA, 0.2),
            },
          }}
        >
          <LanguageIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "language-button",
        }}
        PaperProps={{
          sx: {
            mt: 1.5,
            backgroundColor: FUNDO_PAPEL,
            borderRadius: 2,
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
            border: `1px solid ${withAlpha(VERDE_MENTA, 0.2)}`,
          },
        }}
      >
        {Object.entries(languages).map(([code, name]) => (
          <MenuItem
            key={code}
            onClick={() => handleLangChange(code)}
            selected={currentLang === code}
            sx={{
              fontWeight: currentLang === code ? 600 : 400,
              px: 2,
              py: 1,
              minWidth: 120,
              color: currentLang === code ? VERDE_MENTA : TEXTO_PRIMARIO,
              "&.Mui-selected": {
                backgroundColor: withAlpha(VERDE_MENTA, 0.15),
              },
              "&:hover": {
                backgroundColor: withAlpha(VERDE_MENTA, 0.1),
              },
            }}
          >
            {name}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default LanguageSelector;
